module.exports = __webpack_public_path__ + "static/media/privilege05.7f45fefe.jpg";